import { render, staticRenderFns } from "./PublicCourseItem.vue?vue&type=template&id=c8a9ff00&scoped=true"
import script from "./PublicCourseItem.vue?vue&type=script&lang=ts"
export * from "./PublicCourseItem.vue?vue&type=script&lang=ts"
import style0 from "./PublicCourseItem.vue?vue&type=style&index=0&id=c8a9ff00&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a9ff00",
  null
  
)

export default component.exports